// extracted by mini-css-extract-plugin
module.exports = {"title":"PersonalInformation_title__xfDo7","button":"PersonalInformation_button__tl_0J"};